var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.9979C2.02894 17.4119 2.21848 19.294 3.45963 20.5352C4.92448 22 7.28212 22 11.9974 22C16.7127 22 19.0703 22 20.5352 20.5352C22 19.0703 22 16.7127 22 11.9974C22 7.28212 22 4.92448 20.5352 3.45963C19.294 2.21848 17.4119 2.02895 13.9979 2",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H10C11.8176 7 12.9133 7.89202 13.3196 8.30029C13.4454 8.42673 13.5083 8.48996 13.5092 8.49082C13.51 8.49168 13.5733 8.55459 13.6997 8.68042C14.108 9.08671 15 10.1824 15 12V15M2 7L7 2M2 7L7 12",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/backButton.54302b3e06d53890896ced6beb2a5c1c.svg";
export { ForwardRef as ReactComponent };